import ExclamationCircle from '../../src/legacy/ExclamationCircle.tsx';
export default ExclamationCircle;
